import React, { useState } from 'react';

export interface InputBooleanProps {
    open: boolean;
    onChange: (newValue: boolean) => void;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function useBooleanValue(initialValue?: boolean | undefined): InputBooleanProps {
    const [open, setOpen] = useState(initialValue ?? false);

    function onChange (newValue: boolean) {
        setOpen(newValue)
    }

    return {open, onChange, setOpen};
}
